<template>
  <div class="container">
    <div class="list">
      <a
        class="item"
        v-for="item in list"
        :key="item.cate_id"
        :href="item.article_url"
      >
        <p class="text">{{ item.cate_title }}</p>
        <img class="icon" src="../assets/img/right-arrow.png" />
      </a>
    </div>
    <div class="foot">
      ICP备案号：粤ICP备18022034号-3A<br/>
      广州市乐沃信息科技有限公司 版权所有
    </div>
  </div>
</template>

<script>
export default {
  name: "appAboutus",
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.$ajax({
      headers: {
        "X-DEVICE-TYPE": "4",
        "X-APP-NAME": "musicwow",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      url: process.env.VUE_APP_CONT_API + "api/v1/article/menu/aboutus",
      method: "get",
    }).then((res) => {
      if (res.data.error_code === 0) {
        this.list = res.data.data.cate_list;
      }
    });
  },
};
</script>
<style lang="sass" scoped>
.container
  min-height: 100vh
  background-color: #F5F6F9
.list
  border-top: 1px solid #F8F9FA
.item
  display: flex
  height: 44px
  text-align: left
  background-color: #ffffff
  border-bottom: 1px solid #F8F9FA
  .text
    flex: 1
    line-height: 44px
    padding-left: 18px
    font-size: 14px
    color: #2C2C2F
  .icon
    width: 20px
    height: 20px
    margin: 12px
.foot
  text-align: center
  margin: 16px 0
  font-size: 12px
  line-height: 24px
  color: #959597
</style>